import { ArrowLeftIcon } from '@phosphor-icons/react';
import { createFileRoute, Link } from '@tanstack/react-router';

import { ICON_WEIGHT } from '@/components/icon';

import { SourceSearchPanel } from '@/features/sources';

/**
 * Pulling a flight down from an API rather than dropping a file in.
 *
 * A route of its own, not a dialog over the flight list, for the same reason
 * `flights.$trackId` is: the URL says which of the two is on screen, and a
 * search a pilot wants to come back to survives a reload.
 *
 * It sits *under* `/flights` rather than beside it because what it produces is
 * a flight — the same record, in the same list, deduplicated against the same
 * tracks — and not a fourth destination competing with the three in the header.
 * A static segment under a route that also has a `$trackId` param resolves to
 * this one; the router prefers the literal.
 */
function FetchFlightsPage() {
  return (
    <div className="mx-auto w-full max-w-3xl space-y-4">
      {/* The same back link, in the same place, as a flight's own page. */}
      <Link
        to="/flights"
        className="text-muted-foreground hover:text-foreground inline-flex items-center gap-1.5 text-sm"
      >
        <ArrowLeftIcon aria-hidden="true" weight={ICON_WEIGHT} className="size-4" />
        All flights
      </Link>
      <h1 className="text-lg font-semibold tracking-tight">Fetch a flight</h1>
      <SourceSearchPanel />
    </div>
  );
}

export const Route = createFileRoute('/flights/fetch')({
  component: FetchFlightsPage,
});
